export const WS_EVENTS = {
  // ── Rolls ──────────────────────────────────────────────────────────────
  ROLLS_ROUND_UPDATE: 'rolls_round_update',
  ROLLS_COUNTDOWN_TICK: 'rolls_countdown_tick',
  ROLLS_SPIN_START: 'rolls_spin_start',
  ROLLS_ROUND_FINISHED: 'rolls_round_finished',
  ROLLS_NEW_ROUND: 'rolls_new_round',

  // ── Jetton ─────────────────────────────────────────────────────────────
  JETTON_WAITING: 'jetton_waiting',
  JETTON_COUNTDOWN: 'jetton_countdown',
  JETTON_ROUND_START: 'jetton_round_start',
  JETTON_NEW_BET: 'jetton_new_bet',
  JETTON_CASHOUT: 'jetton_cashout',
  JETTON_CRASH: 'jetton_crash',

  // ── Balloon ─────────────────────────────────────────────────────────────
  BALLOON_STATE: 'balloon_state',
  BALLOON_ERROR: 'balloon_error',
  BALLOON_CANCELLED: 'balloon_cancelled',
  BALLOON_LUCKY_STATUS: 'balloon_lucky_status',
  BALLOON_LUCKY_SAVED: 'balloon_lucky_saved',

  // ── System ─────────────────────────────────────────────────────────────
  ONLINE_COUNT: 'online_count',
  WITHDRAW_UPDATE: 'withdraw_update',
} as const;

export type WsEventType = (typeof WS_EVENTS)[keyof typeof WS_EVENTS];
